<section class="centered-with-padding py-7">
  @if (data.text; as text) {
    <div class="[&_:is(h1,h2,h3,h4,h5,h6)]:font-normal">
      <span
        [innerHTML]="text"
        class="prose max-w-full prose-h1:text-[40px] prose-h2:mb-2 prose-h2:mt-0 prose-h2:text-[35px] prose-h3:my-0 prose-h3:text-[25px] prose-p:my-2.5 prose-p:font-medium prose-p:leading-normal prose-a:hyphens-auto prose-a:whitespace-normal prose-a:break-words prose-a:[overflow-wrap:anywhere] desk:prose-h1:text-[47px] [&_:is(h1,h2,h3,h4,h5,h6)]:font-title"
        handleHtmlLinks></span>
    </div>
  }
</section>
